import { Component, EventEmitter, Output } from '@angular/core';
// import * as XLSX from 'xlsx'; // Install if not used elsewhere

@Component({
  selector: 'app-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss']
})
export class ExportButtonComponent {

  @Output() downloadEvent = new EventEmitter<any>();

  downloadRecords() {
    this.downloadEvent.emit();
  }


}
